<template>
  <div class="minyi-wrapper" :style="{width:width*0.2994+'px'}">
    <div class="minyi-head">民意直通车</div>

    <y-scroll :contentArr="eventReport" :height="height * 0.79" :lineNum="1" :width="width*0.2994" :startTime="12000">
      <div class="minyi-item" slot="scroll" slot-scope="props">
        <img :style="{width: width*0.09375+'px'}" class="event-pic" :src="props.todo.file" v-if="props.todo.file">
        <div class="minyi-info" :style="{fontSize:no125?'15px':'12px',padding:no125?'15px 10px':'5px'}">
          <div style="padding-bottom: 10px">事件上报</div>
          <div :class="textClass">{{props.todo.content}}</div>
        </div>
      </div>
    </y-scroll>
  </div>
</template>
<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    props:{
      height:null,
      width:null,
      eventReport:null,
    },
    computed: {
      no125 () {
        return this.height/0.215>750 || this.width > 1550?true:false
      },
      textClass () {
        return this.height>200?'minyi-text1':'minyi-text2'
      }
    },
    data () {
      return {
        num:[1]
      }
    }
  }
</script>
<style scoped>
  .minyi-wrapper{
    /*width:575px;*/
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 15px;
    color:#444;
  }
  .minyi-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .minyi-item{
    width: 100%;
    height: 100%;
    padding:15px;
    display: flex;
  }
  .minyi-info{
    background: #f1f1f1;
    flex:1;
    /*width: 59.13%;*/
    /*padding:15px 10px;*/
    /*font-size: 15px;*/
    position: relative;
  }
  .minyi-text1{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .minyi-text2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .event-pic{
    margin-right: 15px;
  }
</style>

